<template>
  <div class="Issues" :style="'background-color:' + bgColor + ';'">
    <Banner title="資訊安全" :bannerData="bannerData" />
    <Intro :introData="introData" :color="mainColor" />
    <div>
      <div class="container-xl text-center text-primary">
        <TitleUnderline :title="agendaData.title" :color="mainColor"></TitleUnderline>
      </div>
      <el-card
        v-if="agendaData.contentData.contentList.length > 0"
        shadow="never"
        class="agendaContent"
      >
        <el-affix :offset="96" target=".agendaContent" class="AgendaFixedBox">
          <el-dropdown
            class="AgendaFixedMenu"
            popper-class="AgendaFixedMenuList"
            placement="bottom-start"
            trigger="click"
          >
            <div class="el-dropdown-link">
              {{ agendaData.contentData.active
              }}<span class="el-dropdown-link-icon"
                ><font-awesome-icon :icon="['fas', 'chevron-down']"
              /></span>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  v-for="(agenda, index) in agendaData.contentData.contentList"
                  class="AgendaFixedMenuItem"
                  :class="{ active: agenda.date === agendaData.contentData.active }"
                  @click="changeTab(agenda.date)"
                >
                  {{ agenda.date }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </el-affix>
        <el-tabs v-model="agendaData.contentData.active">
          <el-tab-pane
            v-for="(agenda, index) in agendaData.contentData.contentList"
            :key="index"
            :label="agenda.date"
            :name="agenda.date"
            :tab-change="getAgendaTextHeight()"
          >
            <div class="d-flex justify-content-between align-items-center">
              <div class="ArrowBtn">
                <el-button
                  v-if="index > 0"
                  type="info"
                  plain
                  circle
                  @click="changeTab(index, 'prev')"
                >
                  <font-awesome-icon :icon="['fas', 'chevron-left']" />
                </el-button>
              </div>
              <ul class="AgendaList">
                <li v-for="(item, _index) in agenda.list" :key="_index">
                  <el-row :gutter="50">
                    <el-col :md="10">
                      {{ item.time }}
                      <div v-if="item.tag">{{ item.tag }}</div>
                      <div
                        class="AgendaItemTitle font-Noto-Sans-Bold"
                        v-html="item.title"
                      ></div>
                      <div class="logoImg">
                        <img
                          v-for="(img, i) in item.logo"
                          :key="i"
                          :src="img.src"
                          alt="logo"
                          :style="img.css || ''"
                        />
                      </div>
                    </el-col>
                    <el-col :md="10">
                      <p v-html="item.text"></p>
                      <!-- <p class="AgendaItemText" :class="{'hasMore': item.textHeight > 48,'open': item.showText}">
                                                <p :id="'AgendaItemText-'+index+'-'+_index" v-html="item.text"></p>
                                                <el-button v-if="item.textHeight > 48" link class="more w-100" @click="item.showText = !item.showText">
                                                    <span v-if="item.showText">
                                                        收起<font-awesome-icon :icon="['fas', 'chevron-up']" />
                                                    </span>
                                                    <span v-else>
                                                        更多<font-awesome-icon :icon="['fas', 'chevron-down']" />
                                                    </span>
                                                </el-button>
                                            </p> -->
                    </el-col>
                    <el-col
                      :md="4"
                      style="display: flex; align-items: center; justify-content: center"
                    >
                      <Btn
                        v-if="item.btnStatus !== 'noShow'"
                        :text="getAgendaBtnText(agenda.date, item.time)"
                        :disabled="item.btnStatus === 'disabled'"
                        :href="item.Url"
                      />
                    </el-col>
                  </el-row>
                </li>
              </ul>
              <div class="ArrowBtn">
                <el-button
                  v-if="index + 1 < agendaData.contentData.contentList.length"
                  type="info"
                  plain
                  circle
                  @click="changeTab(index, 'next')"
                >
                  <font-awesome-icon :icon="['fas', 'chevron-right']" />
                </el-button>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </div>
    <div class="Download basic-type" :class="mainColor">
      <div id="DownloadTitle" class="container-xl text-center text-primary">
        <TitleUnderline :title="downloadData.title" :color="mainColor"></TitleUnderline>
      </div>
      <el-row :gutter="30">
        <el-col
          v-for="(item, index) in downloadData.list"
          :key="index"
          :span="6"
          :xs="12"
          class="Item"
        >
          <div class="ItemImg" @click="showBook(item)">
            <img v-if="item.img" :src="item.img" alt="" />
            <img
              v-else
              class="DefaultImg"
              :src="defaultBooksImgArr[getBooksImgArrIndex(index)]"
              alt=""
            />
            <div class="ItemTitle">
              <el-text line-clamp="3">{{ item.title }}</el-text>
            </div>
            <div class="ItemBtn">
              <el-button type="info" plain circle>
                <font-awesome-icon :icon="['fas', 'arrow-down']" />
              </el-button>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="AnimateBgImg" :class="{ animate: DownloadAnimateStatus }">
        <img
          src="../../assets/image/background wave-2.png"
          class="position-absolute top-0 start-0"
        />
      </div>
    </div>
    <div class="Video basic-type" :class="mainColor">
      <div id="VideoTitle" class="container-xl text-center text-primary">
        <TitleUnderline :title="videoData.title" :color="mainColor"></TitleUnderline>
      </div>
      <el-carousel
        ref="VideoList"
        class="VideoList d-md-block d-none"
        arrow="never"
        indicator-position="outside"
        :autoplay="false"
        height="353px"
      >
        <el-button
          class="VideoListBtn Prev"
          type="info"
          circle
          plain
          @click="$refs.VideoList.prev()"
        >
          <font-awesome-icon :icon="['fas', 'chevron-left']" />
        </el-button>
        <el-button
          class="VideoListBtn Next"
          type="info"
          circle
          plain
          @click="$refs.VideoList.next()"
        >
          <font-awesome-icon :icon="['fas', 'chevron-right']" />
        </el-button>
        <el-carousel-item
          v-for="(videoList, index) in getVideoList(videoData.list)"
          :key="index"
        >
          <el-row :gutter="30">
            <el-col v-for="(video, i) in videoList" :span="i === 0 ? 12 : 6">
              <div class="VideoItem" @click="switchVideoModal(video)">
                <img v-if="video.bgImg" :src="video.bgImg" alt="" />
                <img
                  v-else
                  :src="
                    'https://img.youtube.com/vi/' +
                    videoIdFormate(video.videoSrc) +
                    '/mqdefault.jpg'
                  "
                  alt=""
                />
                <div class="VideoItemContent" :class="{ first: i === 0 }">
                  <div class="VideoItemContentBox">
                    <div class="VideoItemDate">{{ video.date }}</div>
                    <div class="VideoItemTitle">{{ video.title }}</div>
                  </div>
                  <div class="VideoItemContentIcon">
                    <font-awesome-icon :icon="['fas', 'play']" />
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-carousel-item>
      </el-carousel>
      <el-carousel
        class="VideoMobileList d-md-none d-block"
        arrow="always"
        indicator-position="outside"
        :autoplay="false"
        height="385px"
      >
        <el-carousel-item v-for="(video, index) in videoData.list" :key="index">
          <div class="VideoItem" @click="switchVideoModal(video)">
            <img v-if="video.bgImg" :src="video.bgImg" alt="" />
            <img
              v-else
              :src="
                'https://img.youtube.com/vi/' +
                videoIdFormate(video.videoSrc) +
                '/mqdefault.jpg'
              "
              alt=""
            />
            <div class="VideoItemContent">
              <div class="VideoItemContentBox">
                <div class="VideoItemDate">{{ video.date }}</div>
                <div class="VideoItemTitle">{{ video.title }}</div>
              </div>
              <div class="VideoItemContentIcon">
                <font-awesome-icon :icon="['fas', 'play']" />
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="AnimateBgImg" :class="{ animate: VideoAnimateStatus }">
        <img
          src="../../assets/image/background wave-3.png"
          class="position-absolute top-0 start-0"
        />
      </div>
    </div>
  </div>
  <el-dialog
    v-model="videoModalData.isShow"
    class="VideoModal"
    align-center
    @close="resetVideo()"
  >
    <iframe
      v-if="videoModalData.source.indexOf('youtu') > -1"
      width="100%"
      style="height: 100%"
      :src="'https://www.youtube.com/embed/' + videoIdFormate(videoModalData.source)"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerpolicy="strict-origin-when-cross-origin"
      allowfullscreen
    ></iframe>
    <video v-else width="100%" controls muted>
      <source :src="videoModalData.source" type="video/mp4" />
    </video>
  </el-dialog>
  <el-dialog
    v-model="bookErrorModalData.isShow"
    class="bookErrorModal"
    center
    align-center
  >
    <div style="text-align: center">
      {{ bookErrorModalData.text }}
    </div>
    <template #footer>
      <el-button
        v-if="bookErrorModalData.showLoginBtn"
        type="success"
        @click="goToLogin()"
        >前往登入頁</el-button
      >
    </template>
  </el-dialog>
</template>
<script>
import axios from "axios";
import { footerStore } from "@/stores/footerStore";
import { useRoute } from "vue-router";
import Banner from "@/components/base/PageBanner.vue";
import Intro from "@/components/base/Intro.vue";
import Btn from "@/components/base/Button.vue";

export default {
  data() {
    return {
      fileLoading: false,
      DownloadAnimateStatus: true,
      VideoAnimateStatus: true,
      bgColor: "",
      mainColor: "",
      videoModalData: {
        isShow: false,
        source: "home_banner.mp4",
      },
      bookErrorModalData: {
        isShow: false,
        showLoginBtn: true,
        text: "",
      },
      defaultBooksImgArr: [
        new URL("@/assets/image/issues/books/1.jpg", import.meta.url).href,
        new URL("@/assets/image/issues/books/2.jpg", import.meta.url).href,
        new URL("@/assets/image/issues/books/3.jpg", import.meta.url).href,
        new URL("@/assets/image/issues/books/4.jpg", import.meta.url).href,
        new URL("@/assets/image/issues/books/5.jpg", import.meta.url).href,
        new URL("@/assets/image/issues/books/6.jpg", import.meta.url).href,
        new URL("@/assets/image/issues/books/7.jpg", import.meta.url).href,
        new URL("@/assets/image/issues/books/8.jpg", import.meta.url).href,
        new URL("@/assets/image/issues/books/9.jpg", import.meta.url).href,
        new URL("@/assets/image/issues/books/10.jpg", import.meta.url).href,
        new URL("@/assets/image/issues/books/11.jpg", import.meta.url).href,
        new URL("@/assets/image/issues/books/12.jpg", import.meta.url).href,
      ],
      bannerData: {
        title: "",
        subTitle: "",
        bgImgSrc: "",
        colorGroup: [],
      },
      introData: {
        title: "",
        content: "",
      },
      agendaData: {
        title: "",
        contentData: {
          active: "",
          contentList: [],
        },
      },
      downloadData: {
        title: "",
        list: [],
      },
      videoData: {
        title: "",
        list: [],
      },
      pageData: {
        security: {
          bgColor: "#F7FBF2",
          mainColor: "grass",
          bannerData: {
            title: "資訊安全",
            subTitle: "資安風暴正在生成",
            bgImgSrc: [
              new URL("@/assets/image/issues/security/banner.jpg", import.meta.url).href,
              new URL("@/assets/image/issues/security/banner-1.jpg", import.meta.url)
                .href,
              new URL("@/assets/image/issues/security/banner.jpg", import.meta.url).href,
              new URL("@/assets/image/issues/security/banner-2.jpg", import.meta.url)
                .href,
            ],
            bgImgSmSrc: [
              new URL("@/assets/image/issues/security/banner-rwd.jpg", import.meta.url)
                .href,
              new URL("@/assets/image/issues/security/banner-rwd-1.jpg", import.meta.url)
                .href,
              new URL("@/assets/image/issues/security/banner-rwd.jpg", import.meta.url)
                .href,
              new URL("@/assets/image/issues/security/banner-rwd-2.jpg", import.meta.url)
                .href,
            ],
            colorGroup: ["#A0D468", "#8CC152"],
          },
          introData: {
            title: "全面防護讓資安長安心入眠",
            content:
              "據資安大廠觀察，台灣遭受資安攻擊居全球之冠！在快速變化的聯網、AI、雲端時代下，在AI強大的分析與歸納功能下，企業更易曝弱點， 而生成式AI以假亂真的發展，更讓資安威脅樣貌難以捉摸，面對層出不窮的資安攻擊，不分產業領域，該如何強健資安體質?  零壹科技數位主題策展資安篇將邀請多位業界專家，從企業營運到內部資安管理，從資安趨勢到治理工具，掌握AI時代下的資安風險，為企業資安體質尋找轉骨良方，讓資安即國安不只是口號，讓你成為危機環伺下的卓越資安企業。",
          },
          agendaData: {
            title: "議程",
            contentData: {
              active: "06/03",
              contentList: [
                {
                  date: "06/03",
                  list: [
                    {
                      title:
                        "生成式AI 時代資安超乎想像<br>趨勢科技善用零信任策略防禦新型態資安戰局",
                      tag: "名人堂",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/TrendMicro.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "14:00-15:00",
                      text:
                        "生成式AI協助企業營運生產力增加了創新機會，卻也為駭客帶來新技術。<br>駭客使用生成式AI精進社交工程詐騙、生成更具吸引力的釣餌，藉此提高得手機會。<br>預期2024年之後駭客將透過結合不同的AI工具(如聊天機器人和偽造語音)製造出如虛擬綁架此類多重面向的威脅。<br>面對大型語言模型(LLM)遭遇「資料下毒(data poison)」也將成為新興威脅，資安領導企業趨勢科技建議，無論威脅如何進化，企業導入零信任策略於每個風險生命週期內，採用整合式資安平台來管理日漸增多的工作負載與防禦措施。<br>【零壹主題策展】特別邀請趨勢科技大型事業處業務協理楊肇謙 Kevin 協理，暢談現代成熟企業如何利用整合式資安平台，藉由逐漸成熟的零信任策略，採用整合式資安平台持續強化供應鏈安全，有效的資安風險管理及防禦策略，大幅提升營運韌性。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/trend_micro/event/activity2024060301/OM1CT",
                      btnStatus: "default",
                    },
                  ],
                },
                {
                  date: "06/04",
                  list: [
                    {
                      title: "零信任策略與安全模型，驅動企業卓越營運的新引擎",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/TrendMicro.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/TrustOne.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "11:00-12:00",
                      text:
                        "零信任架構(Zero Trust Architecture)不論在製造、金融業等高風險行業都是資安的趨勢，透過「永不信任，持續驗證」的精神，所有交易、實體及身份都是不可信任的，直至建立了信任及維持一段時間為止，務實地降低資安風險。<br>由於威脅情勢不斷演變，各種知名的資安事件也持續受到關注，資安領導廠商TrendMicro的Zero Trust 解決方案的主要特點包括身分風險識別和評估裝置風險狀態。<br>其中，TrustONE 防網頁竄改以「Zero Trust 零信任」技術為主軸，將網站資料夾設為「匿蹤保護區」，保護區內的資料夾即使透過安全程序也無法刪寫，不讓駭客有竄改機會，徹底杜絕各種新型態的網頁攻擊手法。<br>本堂課程將以TrendMicro觀察到新型態攻擊手法，並以TrustONE為例，說明當前企業再數位化、AI化過程中的風險，如何善用零信任策略守護營運競爭力。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/trend_micro/event/activity2024060402/BYH0E",
                      btnStatus: "default",
                    },
                    {
                      title: "永不信任，一律驗證",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Forescout.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Microsoft.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "14:00-15:00",
                      text:
                        "零信任可不是把登入方式變更為多因子驗證（MFA, Multi-Factor Authentication）這麼簡單！<br>零信任是精神，也是落實即時查驗及行為分析的框架，這樣每個存取控制的政策落實點確實完成，有效的透過政策決策點檢查權限，包含有效的留存記錄、安全事件分析、存取軌跡，乃至於整合內外部威脅情資，將資安事件的偵查觸角延伸至管理末點。<br>全球網路安全領導者Forescout已經與Microsoft Sentinel聯合防禦整合，此為支援Microsoft Security解決方案的更廣泛計畫的一部分。本堂課程將分享針對資安部門，透過Microsoft Security解決方案如何為網路邊界擴大後的企業提供即時可視性、威脅管理和事件回應，涵蓋企業內網、資料中心、遠距工作、雲端平台、行動裝置、物聯網、工業控制系統和醫療物聯網等各式端點，並能對端點樣態進行即時與持續性風險診斷與緩解（CDM, Continuous Diagnostics & Mitigation），以強化與制定各式裝置的安全基準；進而實施網路分段策略，以執行採用最少許可權的網路存取；自動檢測和隔離控制，共同實現真正的零信任架構。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/forescout/event/activity2024060401/D6ZBB",
                      btnStatus: "default",
                    },
                  ],
                },
                {
                  date: "06/05",
                  list: [
                    {
                      title: "主動式防禦",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/NetScout.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/PaloAltoNetwork.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "11:00-12:00",
                      text:
                        "人工智慧(AI)技術是網路安全的雙面刃，企業級保護機制將愈趨成熟，包括將資安機制整合至開發專案生命週期。<br>同時，關鍵基礎設施(OT)環境仍是高風險遭駭目標，從網路安全趨勢來看，包括激進駭客主義、AI雙面刃、OT仍為易得手的攻擊目標、工具整合提升網路安全、多雲和混合雲安全等五大重點成為當前企業值得關注議題。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/netscout/event/activity2024060501/TCF0N",
                      btnStatus: "default",
                    },
                    {
                      title: "構建資安一站式管理平台",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Cisco.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Splunk.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Veritas.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "14:00-15:00",
                      text:
                        "人工智慧(AI)帶來資安大考驗，端點需要更多防護，也正因為如此，思科收購資安公司Splunk之後，思科+Splunk的技術拓大幅展AI產品線，在既有網路設備中，有效提升數據監測能力，能夠把網路安全風險可視化，並讓企業客戶快速檢測自己的網路安全環境，用機器學習演算法分析過去的攻擊模式。<br>在Splunk構建的Cisco端點安全分析下，搭配Veritas軟體架構，無論是混合雲或各種多元資料，將能有效建構堅韌安全儲存用網路架構，強而有力的備援機制下，面對勒索軟體攻擊時，確保營運備援能力。<br>本次線上研討會將有效說明善用Cisco、Splun、Veritas等解決方案的結合，協助您在AI時代透過完善的網路資安監測能力加上備份/復原解決方案，讓資安團隊安心工作，無任何後顧之憂！",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/cisco/event/activity2024060502/LCWKE",
                      btnStatus: "default",
                    },
                  ],
                },
                {
                  date: "06/06",
                  list: [
                    {
                      title: "Google Cloud Security一站式安全監控與管理",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/GoogleCloud.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Mandiant.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "11:00-12:00",
                      text:
                        "企業上雲比例增加，雲端基礎架構成為IT營運的一環，但安全防護仍為用戶擔憂。<br>許多業者指出，企業內的資安營運中心(SOC)將逐漸吸納雲端資安業務，自動化技術有助抵禦多維度威脅，Google Cloud Secirity旗下的資安品牌Mandiant，擁有動態資安防護、威脅情資等方面的優勢來解決威脅。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/mandiant/event/activity2024060602/5GSAK",
                      btnStatus: "default",
                    },
                    {
                      title: "透過零信任架構建立360°防禦",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Quest.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/OneIdentity.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "14:00-15:00",
                      text:
                        "勒索軟體的威脅在近日可以說是成為所有企業最害怕的資安事件了, 近幾年來的駭客攻擊事件大多都是以微軟Active Directory 環境作為攻擊目標。<br>Quest在這部份提供IT管理者全面的AD 及微軟系統管理解決方案, 包含盤點、稽核及保護、備份還原等工具,加上One Identity提供更多元與更完善的身分治理（IGA）、特權存取管理（PAM）、雙因子驗證等解決方案，兩者完美搭配即可創造安全無虞的治理環境，本節活動將以Quest及One Identity的方案解構當前企業AD環境風險與零信任架構的具體安全實績。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/one_identity/event/activity2024060601/TG4WA",
                      btnStatus: "default",
                    },
                  ],
                },
                {
                  date: "06/07",
                  list: [
                    {
                      title: "掌握OT資安治理關鍵",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/TXONE.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/NOZOMI.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "11:00-12:00",
                      text:
                        "近期根據TXOne Networks調查報告指出，由於多數企業的OT/IT系統協作的機率變高，駭客持續運用勒索軟體，瞄準三大進攻標的：政府、醫療、製造業，同時駭客看準各產業高度依賴軟體服務平台，藉機攻入供應鏈弱點，而地緣政治動盪加劇OT攻擊事件發生，76%的組織對其影響深感憂慮。<br>這些課題都加速各國重視全球OT／ICS法規制定態勢，策略轉變得以驅動組織提升資安態勢和防禦縱深，在追求科技創新的同時，兼顧永續的資訊安全考量。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/nozomi_networks/event/activity2024060702/AO7GZ",
                      btnStatus: "default",
                    },
                    {
                      title: "攻擊是最佳的防禦",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/盧氪賽忒.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Progress.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "14:00-15:00",
                      text:
                        "隨著威脅模式不斷演變，各類型資安解決方案也不斷發展，如果要降低環境中的風險，現代企業開始採用深度防禦策略，以保護資源免受來自外部及內部的威脅。深度防禦 (有時稱為深度安全性或多層安全性) 是一個軍事術語，是指以層層的安全性反制措施，建構一個深具凝聚力、沒有任何弱點的安全環境。<br>所有的Kemp LoadMaster都有將應用程序的流量導出功能，對網路的狀態和效能，提供完美的透明度。Flowmon ADS則是一種異常檢測系統，它利用行為模式來檢測惡意活動。一旦ADS事件被觸發，Flowmon就會運行腳本，將來源IP地址放入防火牆上的隔離區。<br>將Kemp的LoadMaster與Flowmon ADS進行整合，可以形成一個自動化事件檢測和回應系統，協助企業/單位的資源避免外部或內部的資安威脅²。透過Flowmon ADS的行為分析與Kemp LoadMaster的負載平衡功能，允許IT管理員在可自行配置的時間內將攻擊者優先隔離，保有足夠的時間更深入事件調查與資安危害管控。<br>盧氪賽忒提供的ArgusHack產品能紀錄駭客的思維，運用雲端微服務，導入自動化流程，建立入侵與攻擊的模擬平台，找出客戶公司的資安漏洞，提供高品質的特色服務。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/leukocyte-lab/event/activity2024060701/CGCI1",
                      btnStatus: "default",
                    },
                  ],
                },
                {
                  date: "07/15",
                  list: [
                    {
                      title:
                        "引領資訊安全轉型 <br> Palo Alto Networks 善用生成式 AI 建構企業主動防禦",
                      tag: "名人堂",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/PaloAltoNetwork.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "14:00-15:00",
                      text:
                        "生成式AI(Generative AI)已在資安業界產生影響，處在 AI 轉型是趨勢而為的背景下，企業更需謹慎的擬訂「企業的網路安全戰略」，需從人工智慧為核心進行設計、構建，而非採單點產品應對各種單一出現的事件或風險。<br>為了推動國內企業在AI時代更了解當企業主動式防禦的重要性，【零壹主題策展】特別邀請 Palo Alto Networks 台灣區總經理尤惠生 James Yu 、談談目前 Palo Alto Networks是如何看待現代企業善用AI來實現資安的韌性？資安防護的自動化？讓所有企業經營者秒懂 AI 資安布局關鍵，用最省力的方式建構全面安全的企業環境。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/palo_alto_networks/event/activity2024071501/O4BVG",
                      btnStatus: "default",
                    },
                  ],
                },
                {
                  date: "07/16",
                  list: [
                    {
                      title: "零壹資安保母套餐",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/zerone.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "14:00-15:00",
                      text:
                        "最新《2024資安準備度指數》報告指出，僅8%的台灣企業在面對現今資安風險方面準備度達到「成熟」，且具備足夠韌性來因應。<br>然而現在是一個高度互聯的世界，有數十億上網的使用者、裝置可以在任何地方進行連接，並可以使用部署在任何地方的應用程式(App)，不過這些裝置在保護自身免受網路攻擊的能力上程度卻有所不同，例如服務在公有雲或本地端，無論是透過網路進行搜尋，取得服務並連接到應用程式；或連接到本地資料中心；或透過VPN連接到雲端基礎設施；或私有雲、公有雲，所有連線方式都存有安全風險。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/zerone/event/activity2024071601/PNJF2",
                      btnStatus: "default",
                    },
                  ],
                },
                {
                  date: "07/17",
                  list: [
                    {
                      title: "資安防禦如何兼顧速度與精準度",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/CATO.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/奧義智慧.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "14:00-15:00",
                      text:
                        "全球資安攻擊事件不斷，資安問題已成顯學，然資安領域特別著重精準度，因此如何提升資安防禦效率，但又減少誤判率，即是技術關鍵所在。<br>本活動將介紹奧義全新推出的AI資安威脅管理平台Xcockpit運用AI資安模型加強資安應用，並透過Cato SASE Cloud，融合SD-WAN 建立全球網路骨幹網和網路安全服務，加速應用程式效能與安全，有效發揮數位韌性。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/cato_networks/event/activity2024071701/BXP7X",
                      btnStatus: "default",
                    },
                  ],
                },
                {
                  date: "07/18",
                  list: [
                    {
                      title: "零信任檔案存取讓威脅迎刃而解",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/OPSWAT.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Synology.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "14:00-15:00",
                      text:
                        "網路犯罪分子經常利用基於檔案的威脅來破壞系統安全並在使用者的設備或網路上執行惡意活動，因此建立完善的資料存取解決方案來保護企業重要資產不受威脅成為企業重要課題。<br>本活動將介紹如何善用 Synology多元備份工具，確實為資料建立安全基礎，並透過OPSWAT的Deep CDR解決方案通過將檔案分解為離散元件，消除可能有害或不符合規範的物件，並在保留功能的同時重建可用檔案，在不影響檔案完整性的情況下提供全面保護，為企業建立安全的資料傳輸存取流程，讓任何新型態勒索威脅迎刃而解。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/opswat/event/activity2024071801/RJOLX",
                      btnStatus: "default",
                    },
                  ],
                },
                {
                  date: "07/19",
                  list: [
                    {
                      title: "端到端全面的安全防護",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/NetApp.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Cisco.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "14:00-15:00",
                      text:
                        "為了滿足企業日趨大量資料的工作，且GPU密集型應用日益增長的需求，許多企業善用FlexPod結合資料中心運算、儲存與網路的融合式基礎架構，將資料中心基礎架構部署為一個完整系統，在安全、智慧、永續且支援混合環境的平台中，簡化並加速資源部署，以執行企業的所有工作負載，協助加速交付現代化工作負載、確保環境符合未來需求，以及最佳化資源以發揮最大效率。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/cisco/event/activity2024071901/2Q3FX",
                      btnStatus: "default",
                    },
                  ],
                },
              ],
            },
          },
          downloadData: {
            title: "白皮書下載",
            list: [
              {
                title: "2023 Thales資料威脅報告",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/資安/2023 Thales資料威脅報告.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "F5跨分散式環境保護您的Web應用程式和API",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/資安/F5跨分散式環境保護您的Web應用程式和API.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "BMC TrueSight Automation for Servers 解決方案",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/資安/BMC TrueSight Automation for Servers 解決方案.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "Forescout 善用零信任保護機構內的重要資源存取",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/資安/Forescout 善用零信任保護機構內的重要資源存取.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },

              {
                title: "NetApp 協助阻擋整個混合雲環境的網路安全威脅",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/資安/NetApp 協助阻擋整個混合雲環境的網路安全威脅.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "NETSCOUT Arbor Edge Defense-全球最領先的DDoS防護方案",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/資安/NETSCOUT Arbor Edge Defense-全球最領先的DDoS防護方案.jpg",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "OPSWAT保護供應鏈的關鍵",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/資安/OPSWAT保護供應鏈的關鍵.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "Palo Alto Networks Cortex Xsoar重新定義安全協調、自動化與回應",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/資安/Palo Alto Networks Cortex Xsoar重新定義安全協調、自動化與回應.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "Progress 透過網路監控落實製造安全、效率和成功",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/資安/Progress 透過網路監控落實製造安全、效率和成功.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "Splunk 以資料驅動的洞察力，實現全面的可見性、偵測和調查",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/資安/Splunk 以資料驅動的洞察力，實現全面的可見性、偵測和調查.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "Synology 安全性白皮書",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/資安/Synology 安全性白皮書.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "Trend Vision One- 全面且整合式的資安平台",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/資安/Trend Vision One- 全面且整合式的資安平台.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "Veeam_勒索軟體：需要快速恢復的 6 種功能",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/資安/Veeam_勒索軟體：需要快速恢復的 6 種功能.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "TrustONE 駭客眼前消失匿蹤的檔案",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/資安/TrustONE 駭客眼前消失匿蹤的檔案.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "Cato網路快速概覽",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/資安/Cato網路快速概覽.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
            ],
          },
          videoData: {
            title: "影片分享",
            list: [
              {
                title: "NetApp 協助阻擋整個混合雲環境的網路安全威脅",
                date: "",
                bgImg: "",
                videoSrc: "https://youtu.be/9nKj5tt8RLE",
              },
              {
                title: "Trend Vision One",
                date: "",
                bgImg: "",
                videoSrc: "https://www.youtube.com/watch?v=Z7_diFNwKqE",
              },
              {
                title: "打造最簡捷的中小企業零信任資安架構",
                date: "",
                bgImg: "",
                videoSrc: "https://www.youtube.com/watch?v=j8zN6UHCQyA",
              },
              {
                title: "Veritas 勒索軟體猖獗 Backup Exec重裝上陣 🔥🔥",
                date: "",
                bgImg: "",
                videoSrc: "https://www.youtube.com/watch?v=Xandtp-riQI",
              },
              {
                title:
                  "Splunk Enterprise Security 以資料驅動的洞察力，實現全面性的可見性、偵測和調查",
                date: "",
                bgImg: "",
                videoSrc: "https://www.youtube.com/watch?v=XYnmqbBUqBQ",
              },
              {
                title: "跨分散式環境保護您的 Web 應用程式和 API",
                date: "",
                bgImg: "",
                videoSrc: "https://www.youtube.com/watch?v=_cidsXuaFZw",
              },
              {
                title: "【產品Demo影片】XCockpit－自動化資安威脅管理平台",
                date: "",
                bgImg: "",
                videoSrc: "https://www.youtube.com/watch?v=3ybSE2SAsZw",
              },
              {
                title: "Keep IT Simple with Cato SASE Cloud",
                date: "",
                bgImg: "",
                videoSrc: "https://www.youtube.com/watch?v=Z3JPm9xtGf8",
              },
              {
                title: "Forescout_Zero Trust",
                date: "",
                bgImg: "",
                videoSrc: "https://youtu.be/JvQNHwPrcjs",
              },
              {
                title: "NetScout_Arbor_Edge_Defense",
                date: "",
                bgImg: "",
                videoSrc: "https://youtu.be/iBb7d7A5tQU",
              },
              {
                title: "cortex-xsoar-zhtw",
                date: "",
                bgImg: "",
                videoSrc: "https://youtu.be/-FoLEdL85Og",
              },
              {
                title: "Synology 安全性白皮書",
                date: "",
                bgImg: "",
                videoSrc: "https://www.youtube.com/watch?v=o-ayEHPbVAI",
              },
              {
                title: "Veeam 極具彈性，勒索軟體恢復、強化資料保護",
                date: "",
                bgImg: "",
                videoSrc: "https://www.youtube.com/watch?v=klOS5yMkZw4",
              },
              {
                title: "Keep IT Simple with Cato SASE Cloud",
                date: "",
                bgImg: "",
                videoSrc: "https://www.youtube.com/watch?v=Z3JPm9xtGf8",
              },
            ],
          },
        },
        "cloud-service": {
          bgColor: "#EDF3F9",
          mainColor: "aqua",
          bannerData: {
            title: "雲端服務",
            subTitle: "風雲湧動雲端運算環境",
            bgImgSrc: [
              new URL("@/assets/image/issues/cloud/banner.jpg", import.meta.url).href,
              new URL("@/assets/image/issues/cloud/banner-1.jpg", import.meta.url).href,
            ],
            bgImgSmSrc: [
              new URL("@/assets/image/issues/cloud/banner.jpg", import.meta.url).href,
              new URL("@/assets/image/issues/cloud/banner-rwd-1.jpg", import.meta.url)
                .href,
            ],
            colorGroup: ["#4FC1E9", "#3BAFDA"],
          },
          introData: {
            title: "無所不在的串連創造營收無限可能",
            content:
              "近年動輒上千億參數量的LLM模型迭代而出，再次帶動雲端熱潮，不論是提供大量數據存儲和處理，或是模型的訓練與運行，雲端可說是數據最佳的停泊港、孵化所。<br>此外，根據統計80%以上企業同時使用2個以上雲服務，數據如何跨雲、跨平台進行整合、自由地流動轉換，並進行統一的資料防護管理，已成企業當前最大的使用挑戰!  本次零壹科技數位主題策展雲端篇，特別邀請多位專家探討雲端如何成為靈活高效、敏捷永續的數位韌性、布建成本、高度自動化需求等重要議題，探討不同企業該有的適性雲端環境，助您撥雲見日，打造一流數位企業。",
          },
          agendaData: {
            title: "議程",
            contentData: {
              active: "06/11",
              contentList: [
                {
                  date: "06/11",
                  list: [
                    {
                      title: "實現最佳性能運算力的託管式安全服務",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Akamai.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/CATO.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "11:00-12:00",
                      text:
                        "企業數位轉型為雲端市場新一波成長動力，但企業轉型過程存在高技術門檻、複雜情境和嚴格資料法規等挑戰。<br>因而，實現最佳性能運算力、多層次、託管式的安全服務，分散式雲服務成為雲端供應鏈業者值得關注的重點。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/akamai/event/activity2024061103/N6Q5G",
                      btnStatus: "default",
                    },
                    {
                      title: "企業上雲與資安議題觀察",
                      tag: "專家洞察",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/digitimes.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "13:00-14:00",
                      text:
                        "這場講題將關注企業上雲及資安問題。首先，我們將探討網路攻擊的發展趨勢，這直接影響著企業數位轉型。接著，數位轉型凸顯了資安的關鍵性，尤其在混合雲和多雲趨勢下，企業必須適應共同責任模型與零信任架構以應對雲端資安挑戰。其次，我們將討論企業上雲所帶來的複雜IT架構風險，這也是數位轉型過程中需要面對的重要議題之一。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/zerone/event/activity2024061102/R82YF",
                      btnStatus: "default",
                    },
                    {
                      title:
                        "打造超智能工作模式<br>持續創新、企業 AI 轉型成功之雲部署",
                      tag: "名人堂",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Microsoft.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "14:00-15:00",
                      text:
                        "各種生成式 AI 的服務爆發，造就龐大的網路數據庫、大型語言模型算法的成熟度、深度學習需要的演算力。各行各業都在規劃如何加入AI浪潮時，雲服務業者競逐生成式人工智慧（AI）商機，也讓熱潮已久的雲部署策略重新值得另外檢視。<br>目前發展生成式 AI 的企業，其目標都是為了提高生產力，但傳統的雲佈署不一定適用新形態大量數據與演算力的應用，【零壹主題策展】特別邀請台灣微軟全球合作夥伴解決方案事業群總經理 Jerry Chen，暢談目前在各行各業發展發展類似GPT等大型語言模型的服務該如何規劃？ 國內企業如何透過微軟的 Azure OpenAI 建立專屬自己的服務？ 透過Jerry深度分析，讓微軟與零壹技術團隊協助業者成功啟動數位轉型!!",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/microsoft/event/activity2024061101/REZQ4",
                      btnStatus: "default",
                    },
                  ],
                },
                {
                  date: "06/12",
                  list: [
                    {
                      title: "完整雲端安全服務為企業架構未來",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/PaloAltoNetwork.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "11:00-12:00",
                      text:
                        "雲端遷移的靈活度與安全性成為現今IT人員最高宗旨，Palo Alto Networks與AWS合作AWS Firewall Manager中提供雲端次世代防火牆(NGFW)，使得AWS用戶可以使用Firewall Manager，來集中配置和管理雲端NGFW資源，並跨多帳戶和虛擬私有雲，監控不合規定的配置，近年推出的Prisma Cloud更能保護從程式碼到雲端的應用程式。<br>成為最為全面的適用於AWS 的雲端原生應用程式保護平台(CNAPP)來保護雲端資源和資產。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/palo_alto_networks/event/activity2024061201/H65Q8",
                      btnStatus: "default",
                    },
                    {
                      title: "輕而易舉的多雲安全管理",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/F5.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/羽昇.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "14:00-15:00",
                      text:
                        "駭客攻擊手法以及流量變大變廣的趨勢來臨，相對以往單靠地端的防禦設備是無法支援應用服務同時達到穩定及安全兩面兼具的狀態，F5提供強大邊緣運算資安平台整合，能串接各種公有雲，防禦規則進行分層治理，達到資安防禦又廣又深的目的，支援所有的應用服務架構，亦節省防禦資安及人力的配置。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/f5/event/activity2024061202/ZQQPC",
                      btnStatus: "default",
                    },
                  ],
                },
                {
                  date: "06/13",
                  list: [
                    {
                      title: "Logitech AI 科技開創混合辦公新篇章",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Logitech.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Microsoft.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "11:00-12:00",
                      text:
                        "近年隨著全球企業對遠距工作和混合辦公的需求增加，視訊會議設備市場迅速發展，企業正積極尋找更彈性靈活的解決方案，以滿足多樣化的工作場景需求。<br>面對辦公型態的轉變，Logitech for Business打造商務協作展示中心，從辦公需求和工作體驗出發，結合AI科技打造多元協作與辦公空間，搭配完整「商務視訊設備」和「個人協作鍵鼠、耳機」，實際展演全系列方案，帶給您身臨其境的會議體驗，開啟辦公新邏輯！",
                      Url:
                        "https://www.zerone.com.tw/product/brand/logitech/event/activity2024061302/DQ7XZ",
                      btnStatus: "default",
                    },
                    {
                      title: "建構高度自動化及客製化之企業雲平台",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Cisco.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Splunk.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Veritas.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "14:00-15:00",
                      text:
                        "無論是虛擬、實體或雲端平台提供最佳化與智慧型的資料保護功能，往往是企業IT人員苦心追求的雲平台環境；長久以來善用Veritas Alta該平台可助力企業將關鍵業務工作負載遷移到雲端，進一步鞏固其資料自治戰略，於此同時Splunk觀測雲能利用開源監控專案所打造的觀測雲，供IT和DevOps團隊能夠跨雲，收集統一且一致的指標、追蹤和日誌，無論在任何規模，這些資料都能不採樣地即時收集。<br>本課程即是說明如何利用Cisco地端與雲端的串聯，成功利用Veritas和Splunk觀測雲服務建立屬於企業自身高度自動化及客製化之企業雲平台。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/cisco/event/activity2024061301/CCBGK",
                      btnStatus: "default",
                    },
                  ],
                },
                {
                  date: "06/14",
                  list: [
                    {
                      title: "引領AI時代、安全無所不在",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Microsoft.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/AvePoint.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "11:00-12:00",
                      text:
                        "Copilot for Microsoft 365 的問世讓企業員工可以更好地搜索、發現和理解資料，從而最終提高人工智慧（AI）的輸出，但使用過程為了保護資料，使用者可透過AvePoint協助Copilot 數據優化，例如，AvePoint 可以幫助客戶在導入 Copilot 時更加順利，並探討如何為企業在 AI 來臨時代做好準備。<br>AvePoint 還提供了一套Opus 的 AI 驅動分類功能，使組織能夠識別高價值內容，並在大規模上進行標記和分類，同時自動應用適當的生命週期政策。 這有助於使您的數據即使在沒有大量手動輸入的情況下也能為人工智慧做好準備。<br>此外，通過 AvePoint Opus 與 Copilot for Microsoft 365 的無縫整合，您可以確保這些政策和控制應用於您的數據，即使在您的 Copilot for Microsoft 365 採用不斷增長的同時，也能保持有效的資訊管理實踐。",
                      Url:
                        "https://www.zerone.com.tw/product/brand/avepoint/event/activity2024061402/UWLI6",
                      btnStatus: "default",
                    },
                    {
                      title: "從地端至雲端- 雲地混合無阻暢行",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/NetApp.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/AWS.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "14:00-15:00",
                      text:
                        "為了搭建無與倫比的企業雲端解決方案，許多企業已經開始善用全託管儲存服務，從地端至雲端，NetApp都可為自選的雲端和資料中心提供雲端儲存服務和企業級資料管理功能。<br>AWS已將NetApp技術整合至他們的雲端儲存和資料服務策略中，運用已整合至AWS的原生體驗，即可輕鬆延伸到雲端、移轉應用程式、減少管理成本但能享受NetApp廣泛的資料服務套件，將讓IT工作更加輕鬆。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/netapp/event/activity2024061401/GZVH6",
                      btnStatus: "default",
                    },
                  ],
                },
              ],
            },
          },
          downloadData: {
            title: "白皮書下載",
            list: [
              {
                title: "趨勢科技 Cloud One",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/雲端/趨勢科技 Cloud One.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "F5-如何跨多雲端快速部署應用程式",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/雲端/F5-如何跨多雲端快速部署應用程式.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "Microsoft 365 的 Copilot 最新版本更新",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/雲端/Microsoft 365 的 Copilot 最新版本更新.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "NetApp 利用專為複雜的多雲環境所打造的解決方案",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/雲端/NetApp 利用專為複雜的多雲環境所打造的解決方案.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "Nutanix 雲端基礎架構",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/雲端/Nutanix 雲端基礎架構.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "Palo Alto Networks Prisma Cloud 降低風險、減少入侵、提高效率",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/雲端/Palo Alto Networks Prisma Cloud 降低風險、減少入侵、提高效率.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "Splunk Cloud Platform 串流、搜尋、分析、視覺化資料並對其採取行動",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/雲端/Splunk Cloud Platform 串流、搜尋、分析、視覺化資料並對其採取行動.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "Thales-2023雲端安全研究",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/雲端/Thales-2023雲端安全研究.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "VMware Cloud Foundation 加速達到業務成果",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/雲端/VMware Cloud Foundation 加速達到業務成果.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "Avepoint x Copilot 成功框架",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/雲端/Avepoint x Copilot 成功框架.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
            ],
          },
          videoData: {
            title: "影片分享",
            list: [
              {
                title: "Xi 雲端服務：維運混合雲和多雲環境",
                date: "",
                bgImg: "",
                videoSrc: "https://youtu.be/tUprMOvRJdQ?si=NX7Plejo3eGimG5e",
              },
              {
                title: "NetApp_夢工廠首選雲端資料服務供應商",
                date: "",
                bgImg: "",
                videoSrc: "https://www.youtube.com/watch?v=XBFp2rAW9JE",
              },
              {
                title: "Cisco Meraki 雲端管理的智慧化 IT 解決方案",
                date: "",
                bgImg: "",
                videoSrc: "https://www.youtube.com/watch?v=pKLSNn1iECw",
              },
              {
                title: "混合雲應用InfoScale全面資料防護",
                date: "",
                bgImg: "",
                videoSrc: "https://www.youtube.com/watch?v=JHFjDdVkwCY",
              },
              {
                title: "Splunk Cloud Platform 串流、搜尋、分析、視覺化資料並對其採取行動",
                date: "",
                bgImg: "",
                videoSrc: "https://www.youtube.com/watch?v=aoapDgKiMuU",
              },
              {
                title: "PANW_prisma-cloud-aag-zhtw",
                date: "",
                bgImg: "",
                videoSrc: "https://youtu.be/a38CmMfzal4",
              },
              {
                title: "VMware Cloud Foundation 加速達到業務成果",
                date: "",
                bgImg: "",
                videoSrc: "https://youtu.be/6rQprI6ER9I",
              },
            ],
          },
        },
        "storage-and-backup": {
          bgColor: "#EFEDE9",
          mainColor: "lavander",
          bannerData: {
            title: "儲存與備份系統",
            subTitle: "資料生成－儲存戰局升溫",
            bgImgSrc: [
              new URL("@/assets/image/issues/storage/banner.jpg", import.meta.url).href,
              new URL("@/assets/image/issues/storage/banner-1.jpg", import.meta.url).href,
            ],
            bgImgSmSrc: [
              new URL("@/assets/image/issues/storage/banner-rwd.jpg", import.meta.url)
                .href,
              new URL("@/assets/image/issues/storage/banner-rwd-1.jpg", import.meta.url)
                .href,
            ],
            colorGroup: ["#AC92EC", "#967ADC"],
          },
          introData: {
            title: "每一家公司都能是智能數據基地",
            content:
              "AI、5G、IoT所形成的完美串聯模式正席捲這個世界，數以億計的設備不間斷生成數據，透過5G傳輸，驅動AI運算與回應，當資料量越多，AI精度越高，企業的價值也就越能展現，可說智慧化應用當道時代，數據力決定了企業的市場競爭力。因此新時代的資料中心在資料備份還原、安全環境、彈性移轉成為必備功能。<br>面對這波趨勢，本次零壹科技數位主題策展儲存篇，將從各種混合雲的布建模式、建立永續IT、資料安全、資料備援等重要議題，邀請第一線作戰的業內專家共同分享其中關鍵，助您佈署完美的新時代資料基地。",
          },
          agendaData: {
            title: "議程",
            contentData: {
              active: "06/17",
              contentList: [
                {
                  date: "06/17",
                  list: [
                    {
                      title:
                        "WIN IN FLASH，進化資料以簡馭繁！<br>NetApp高效能全快閃儲存與混合雲驅動企業級數據革命",
                      tag: "名人堂",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/NetApp.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "14:00-15:00",
                      text:
                        "以雲端、資料為中心的 NetApp，常年位居台灣儲存設備市佔率第一，因應企業多種雲端空間管理及 AI 的需求發展，強大的 Flash 技術能以優異的速度和回應能力來處理效能密集型工作負載，搭配適用的系統、軟體和雲端服務，幫助企業從資料中心到雲端以最佳化的方式執行應用程式。<br>為了推動國內企業更了解當企業資料的魅力與實績，【零壹主題策展】特別邀請 NetApp 技術總監 Lawrence、談談目前 NetApp 是如何看待現代企業如何利用儲存技術改善工作負載、運用混合雲佈署資料，發掘企業前所未有的潛力？NetApp 跟在地技術團隊如何深入服務台灣企業？ 讓所有數據工作者一起以簡馭繁，完成偉大的數據任務。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/netapp/event/activity2024061701/IY7SG",
                      btnStatus: "default",
                    },
                  ],
                },
                {
                  date: "06/18",
                  list: [
                    {
                      title: "資料恢復機制",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/PaloAltoNetwork.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Synology.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "14:00-15:00",
                      text:
                        "面對網路攻擊的遽增，近年企業都在強化數位韌性，包括資料上雲、跨境的異地資料備援、資安強化等項目都在進行，預算規模也持續拉升，因此不論何種攻擊，建構完善備援機制，確保營運不中斷被視為是最安全的資安策略。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/palo_alto_networks/event/activity2024061801/6TUHZ",
                      btnStatus: "default",
                    },
                  ],
                },
                {
                  date: "06/19",
                  list: [
                    {
                      title: "全方位資料中心",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Cisco.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Veritas.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "14:00-15:00",
                      text:
                        "為了符合現代的資料中，四大關鍵分別是部署智慧自動化、改善常規營運、提供大規模效能、延伸網路管理。<br>Cisco雲端資料中心的所有技術，包含整合運算系統(Unified Computing)、虛擬化技術與整合的網路架構(Unified Fabric)正是為了現代資料中心提供與時俱進的強化功能，提供專為擴充而打造的資料中心網路解決方案，具備領先業界的自動化、可程式化與即時能見度；而在備援管理部份，同時善用管理主控台Veritas Alta，可通過統一管理平台提供跨邊緣、資料中心和雲的全資料資產的統一視圖和控制，協助每一間企業打造可信賴全方位資料中心。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/cisco/event/activity2024061901/HDLHM",
                      btnStatus: "default",
                    },
                  ],
                },
                {
                  date: "06/20",
                  list: [
                    {
                      title: "打造企業韌性：實現無縫的本地服務備份和災難復原",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/AWS.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Veeam.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "14:00-15:00",
                      text:
                        "在當今數據驅動的世界中，數據保護對於企業的成功至關重要，Veeam 和 AWS 攜手為企業提供強大且可靠的數據保護解決方案，幫助企業將本地服務備份至 AWS，以及在 AWS 環境中進行服務復原。<br>Veeam 是業界領先的備份解決方案領導者，可提供可靠、靈活且易於使用的數據備份。<br>AWS 身為公有雲平台的龍頭，提供安全且可擴展的雲基礎架構，以確保數據的安全性和可用性。<br>在 Veeam 和 AWS 的幫助下，企業可以掌握如何幫助企業實現無縫的本地服務備份和災難恢復以外，並同時確保備份安全、管理備份權限並應對地緣政治挑戰。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/veeam/event/activity2024062001/FMYYV",
                      btnStatus: "default",
                    },
                  ],
                },
                {
                  date: "06/21",
                  list: [
                    {
                      title: "混合雲守護者：資料保護任你行",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/NetApp.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Microsoft.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/AWS.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/GoogleCloud.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "14:00-15:00",
                      text:
                        "企業在面臨一連串的網路威脅，從營運永續的角度必須強化資安防護的投資，因為當網軍駭客攻擊，一旦造成支付贖金也無法取回資料的困境，平時的資料備份將考驗企業面對資安事件的韌性指標。<br>企業儲存主要應用面有三，包括儲存、備份與分享，企業資料在儲存的同時，也會需要檔案共享，為避免資料受駭客攻擊，近期一寫多讀(WORM)不能竄改的功能也受到關注，而資料備份需求更是每年爆炸式成長。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/netapp/event/activity2024062101/QU9M5",
                      btnStatus: "default",
                    },
                  ],
                },
              ],
            },
          },
          downloadData: {
            title: "白皮書下載",
            list: [
              {
                title:
                  "Palo Alto Networks 雲端安全聚焦 – 企業如何簡化多雲端環境中的安全性",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/儲存與備份/Palo Alto Networks 雲端安全聚焦 – 企業如何簡化多雲端環境中的安全性.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "NetApp 適用於關鍵企業應用程式的 SAN 儲存",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/儲存與備份/NetApp 適用於關鍵企業應用程式的 SAN 儲存.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "Nutanix 統一儲存管理",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/儲存與備份/Nutanix 統一儲存管理.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "Veeam_Microsoft 365 備份懶人包",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/儲存與備份/Veeam_Microsoft 365 備份懶人包.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
            ],
          },
          videoData: {
            title: "影片分享",
            list: [
              {
                title: "NetApp ASA 以簡化的資料保護及資料管理功能提供持續資料存取",
                date: "",
                bgImg: "",
                videoSrc: "https://youtu.be/TtNftE8j7yc",
              },
              {
                title: "打造新型態IT基礎架構維運模式",
                date: "",
                bgImg: "",
                videoSrc: "https://www.youtube.com/watch?v=1Pbmk2WNlMQ",
              },
              {
                title: "使用Veritas Alta Recovery Vault架構成為您的避風港",
                date: "",
                bgImg: "",
                videoSrc: "https://www.youtube.com/watch?v=zGo1nTBvrR4",
              },
              {
                title: "customer-spotlight-multicloud-security-tw",
                date: "",
                bgImg: "",
                videoSrc: "https://www.youtube.com/watch?v=6Zyda5RDzFw",
              },
            ],
          },
        },
        "ai-big-data": {
          bgColor: "#F9EDED",
          mainColor: "bittersweet",
          bannerData: {
            title: "AI大數據",
            subTitle: "賦能未來AI無所不在",
            bgImgSrc: [
              new URL("@/assets/image/issues/AI/banner.jpg", import.meta.url).href,
              new URL("@/assets/image/issues/AI/banner-1.jpg", import.meta.url).href,
              new URL("@/assets/image/issues/AI/banner.jpg", import.meta.url).href,
              new URL("@/assets/image/issues/AI/banner-2.jpg", import.meta.url).href,
            ],
            bgImgSmSrc: [
              new URL("@/assets/image/issues/AI/banner-rwd.jpg", import.meta.url).href,
              new URL("@/assets/image/issues/AI/banner-rwd-1.jpg", import.meta.url).href,
              new URL("@/assets/image/issues/AI/banner-rwd.jpg", import.meta.url).href,
              new URL("@/assets/image/issues/AI/banner-rwd-2.jpg", import.meta.url).href,
            ],
            colorGroup: ["#FC6E51", "#E9573F"],
          },
          introData: {
            title: "算力定義產業競爭力",
            content:
              "調研機構預測未來數年全球AI市場將會快速成長，調查顯示台灣也有近6成企業導入AI有意願來因應即將充滿AI應用的市場；而算力就像是電力，是智慧時代的支撐，也在一定程度上決定AI的進度。<br>根據國際研究中心資料，全球企業在人工智慧軟體、硬體和服務的總投資將超 850 億美元；預計將在2025年增至2,045億美元，五年複合增長率(CAGR)達24.5%。<br>本次零壹科技數位主題策展AI篇，將邀請眾多AI領域國際領導企業代表，從生成式語言模型的進步、機器學習的無所不在，探討各個行業領域的關鍵應用為何?如何透過高度運算最快時間優化營運與服務模式，本次課程將帶來含金量相當高的業界第一手消息，敬邀您準時收看。",
          },
          agendaData: {
            title: "議程",
            contentData: {
              active: "06/25",
              contentList: [
                {
                  date: "06/25",
                  list: [
                    {
                      title: "生成式AI發展與市場觀察",
                      tag: "專家洞察",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/digitimes.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "11:00-12:00",
                      text:
                        "這場講題將探討生成式AI的發展與市場趨勢。首先，我們會觀察生成式AI的發展趨勢，包括AI演算法和大型語言模型（LLM）。接著，我們將關注生成式AI市場的軟硬體趨勢，特別是運算晶片和應用程式的發展。最後，我們將通過企業生成式AI應用案例，深入了解其在實際業務中的應用與效果。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/zerone/event/activity2024062502/MP4VD",
                      btnStatus: "default",
                    },
                    {
                      title: "讓AI加持企業數據視野",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Pyramid.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Tableau.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "14:00-15:00",
                      text:
                        "資料視覺化是許多商業智慧工具的一部分，也是進階分析的關鍵<br>透過AI加持的資料視覺化能協助人們理解現今產出的所有資訊或資料，透過資料視覺化，資訊以圓餅圖、圖表或其他視覺呈現類型等圖形形式顯示。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/pyramid_analytics/event/activity2024062501/LBWAY",
                      btnStatus: "default",
                    },
                  ],
                },
                {
                  date: "06/26",
                  list: [
                    {
                      title:
                        "生成式 AI 讓一切創新成為可能！<br>善用 GPU 特性，力助企業強化運算引擎效能",
                      tag: "名人堂",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/NVIDIA.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "11:00-12:00",
                      text:
                        "隨著企業營運越來越多挑戰性的難題可以被 AI 從各面向來解決，領先的 AI 計算能力已成為競爭優勢關鍵。<br>但是許多組織仍然束縛於過去資料中心中的既有架構，從而無法動態反應企業應對 AI 迅速發展的狀態。<br>為了讓每個企業都能普遍使用 AI，NVIDIA 不斷提出更新加速計算架構，了解其中關鍵將能掌握其中關鍵在生成式人工智慧(Generative AI)狂潮影響之下，AI相關硬體、軟體和應用面需求有何變化，而GPU主要供應者NVIDIA與軟體、雲服務商的關係，又將如何演變？【零壹主題策展】特別邀請NVIDIA資深協理康勝閔(ERIC)，暢談目前在各行各業在評估GPU使用的效益 ? 時而至今的GPU的效能對於當前的 AI 模型有哪些成功故事？邀請您一同進入最新一波的超高運算時代。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/nvidia/event/activity2024062603/GVEIT",
                      btnStatus: "default",
                    },
                    {
                      title: "防禦網路犯罪所用 AI 工具",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/PaloAltoNetwork.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/NetApp.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/NVIDIA.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "14:00-15:00",
                      text:
                        "網路威脅加劇，資安人力卻總是不足，如何翻轉攻防不對稱的局勢是資安發展重心，而AI正是大家期待已久的技術。<br>資安業者採用AI/ML提升本身產品與服務的能力，並非新鮮事，甚至不少廠商強調，資安解決方案要以AI為中樞，在GPT-4、PaLM 2、Llama 2等多個大型語言模型(LLM)引領之下，不僅帶動生成式AI興起，也再次掀起AI資安浪潮。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/netapp/event/activity2024062602/LPH4C",
                      btnStatus: "default",
                    },
                  ],
                },
                {
                  date: "06/27",
                  list: [
                    {
                      title:
                        "賦能AI完美落地<br>Taiwan AI Labs 如何協助產業無痛轉型、升級台灣 AI 應用",
                      tag: "名人堂",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/TaiwanAILab.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "11:00-12:00",
                      text:
                        "生成式 AI 浪潮持續火熱，AI 科技進展之下，每家企業都在思考與學習，打造可信任的生成式服務，這也表示 AI 產業化的時代已經發生，為了成為領先企業，「AI賦能」與「數位轉型」的應用服務落地將成為產業競爭力基礎。<br>在實際應用部分，市面上就有許多語音轉文字生成平台，台灣人工智慧實驗室 ( Taiwan AI Labs ) 開發的雅婷逐字稿便是相當成功的案例，協助使用者善用語言模型辨識能力進行文字工作，同時大型語言模型結合的雅婷智慧在影視音無縫接軌，打造世界最擬真的 AI vocal與AI主播，完整商轉落地，有效提升商業價值。<br>許多組織對生成式AI(Generative AI)應用「FedGPT」大感興趣，但在投資風險與策略上因較無經驗需要借鏡成功者經驗，【零壹主題策展】特別邀請 Taiwan AI Labs 創辦人杜奕瑾，暢談現代企業發展 Gen AI 服務該有的風險思維與戰略規劃，並就 Taiwan AI Labs 如何讓雅婷智慧為各種產業提供內容應用的API串接經驗，為國內業者提供寶貴經驗分享，加速企業 AI 服務革新轉型！",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/taiwanailabs/event/activity2024062702/RVODF",
                      btnStatus: "default",
                    },
                    {
                      title: "頂級服務、AI員工出任務",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Microsoft.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/碩網.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "14:00-15:00",
                      text:
                        "AI 的突破性進展，對微軟以及透過微軟技術來提高效率、優化客戶體驗並取得新突破的開發人員，產生深遠的影響。本次研討會將邀請您探索 Microsoft 領先業界的 AI 支援開發工具。分享更多關於 GPT-4o 及 Azure AI 服務的最新資訊、與您分享全球上百萬開發者為之瘋狂的GitHub Copilot 到底在紅什麼?<br>同時，本場次我們也邀請專注企業對話式 AI 服務已逾 20 年的專業合作夥伴碩網資訊，分享結合生成式AI數位轉型應用、碩網解決方案如何協助企業打造AI服務應用藍圖。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/microsoft/event/activity2024062701/NH0NQ",
                      btnStatus: "default",
                    },
                  ],
                },
                {
                  date: "06/28",
                  list: [
                    {
                      title: "NVIDIA+Nutanix 專屬企業打造支援AI功能的基礎架構",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/NVIDIA.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Nutanix.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "14:00-15:00",
                      text:
                        "新的AI時代到來，提高用戶滿意度並加深客戶關係時，它們正在尋求利用AI技術來增強客戶服務運營，為了協助企業發揮AI的威力，Nutanix已經認證了 Nutanix AHV虛擬化管理程序，用於 NVIDIA®AI Enterprise，這是支持 NVIDIA AI 平台的企業級軟件，用NVIDIA先進GPU和尖端AI解決方案的加速計算，NVIDIA AI Enterprise賦予組織發掘AI無限可能性的能力。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/nutanix/event/activity2024062801/QS1XP",
                      btnStatus: "default",
                    },
                  ],
                },
              ],
            },
          },
          downloadData: {
            title: "白皮書下載",
            list: [
              {
                title: "BMC Helix Operations Management with AIOps 解決方案",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/AI/BMC Helix Operations Management with AIOps 解決方案.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "Palo Alto Networks 機器學習式新世代防火牆規格和功能摘要",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/AI/Palo Alto Networks 機器學習式新世代防火牆規格和功能摘要.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "NetApp AI：從邊緣到核心再到雲端，聰明管理人工智慧工作負載及資料",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/AI/NetApp AI：從邊緣到核心再到雲端，聰明管理人工智慧工作負載及資料.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "Nutanix 簡化你的 AI 創新學習曲線",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/AI/Nutanix 簡化你的 AI 創新學習曲線.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
            ],
          },
          videoData: {
            title: "影片分享",
            list: [
              {
                title:
                  "NetApp AI：從邊緣到核心再到雲端，更聰明地管理人工智慧工作負載及資料",
                date: "",
                bgImg: "",
                videoSrc: "https://youtu.be/j9RZKkM0CIk",
              },
              {
                title: "BMC Helix Operations  Management with AIOps",
                date: "",
                bgImg: "",
                videoSrc: "https://youtu.be/O6_wbwmMlgI?si=42AS7Deg1n-tIGtl",
              },
              {
                title: "Get automated, AI-powered analytics, with Tableau Pulse",
                date: "2024.6.3",
                bgImg: "",
                videoSrc: "https://www.youtube.com/watch?v=g8_mLiY9h4M",
              },
              {
                title: "Data Science & AI Overview",
                date: "",
                bgImg: "",
                videoSrc: "https://www.youtube.com/watch?v=ufawEA4i7wc",
              },
              {
                title: "ml-powered-ngfw-specsheet-zhtw",
                date: "",
                bgImg: "",
                videoSrc: "https://www.youtube.com/watch?v=d4NG5k4kAGM",
              },
              {
                title: "VMware Private AI",
                date: "",
                bgImg: "",
                videoSrc: "https://youtu.be/1Q_QVQqknfg",
              },
            ],
          },
        },
        "k8s-and-virtualization": {
          bgColor: "#F9F8ED",
          mainColor: "sunflower",
          bannerData: {
            title: "K8s與虛擬化",
            subTitle: "容器引擎啟動開發革命",
            bgImgSrc: [
              new URL("@/assets/image/issues/K8s/banner.jpg", import.meta.url).href,
              new URL("@/assets/image/issues/K8s/banner.jpg", import.meta.url).href,
              // new URL("@/assets/image/issues/K8s/banner-1.jpg", import.meta.url).href,
            ],
            bgImgSmSrc: [
              new URL("@/assets/image/issues/K8s/banner-rwd.jpg", import.meta.url).href,
              new URL("@/assets/image/issues/K8s/banner-rwd.jpg", import.meta.url).href,
              // new URL("@/assets/image/issues/K8s/banner-rwd-1.jpg", import.meta.url).href,
            ],
            colorGroup: ["#FFCE54", "#F6BB42"],
          },
          introData: {
            title: "虛擬化環境就是你的創意生成小天地",
            content:
              "虛擬機器是所有業務運作的核心，負責託管幾乎所有工作負載，從對任務至關重要的備份應用程式到開發/測試環境，都在涵蓋範圍內。而容器和 VM 都有其用途：事實上，許多容器部署都會使用 VM 作為主機作業系統，而不是直接在硬體上執行，尤其是在雲端中執行容器時。正因為如何，利用開源容器創造服務創新模式成為至關重要的課題。<br>本次零壹科技數位主題策展K8s+虛擬化篇，將從容器串連和搬遷資料、容器架構/虛擬化架構、整合型應用程式邀請深度技術專家講解其中重要資訊，我們將分析您適合的架構模式還有優化策略，持續顛覆傳統，創造持續創新的企業業務模式。",
          },
          agendaData: {
            title: "議程",
            contentData: {
              active: "07/02",
              contentList: [
                // {
                //   date: "07/01",
                //   list: [
                //     {
                //       title:
                //         "混合多雲平台簡化維運，彈性擴充與遷移！<br>透過 Nutanix隨時隨地執行現代化應用程式",
                //       tag: "名人堂",
                //       logo: [
                //         {
                //           src: new URL(
                //             "@/assets/image/issues/logo/Nutanix.png",
                //             import.meta.url
                //           ).href,
                //         },
                //       ],
                //       time: "14:00-15:00",
                //       text:
                //         "混企業為了推動數位轉型，都有可能選擇建立混合雲 Kubernetes 環境，為擴充和遷移雲端原生工作負載方面獲得更大的靈活性創造了良好條件。<br>但同時兩個主要挑戰都需解決，建立和維護生產級 Kubernetes 堆疊是一項複雜的工作；其次跨公有雲和私有雲運行 Kubernetes 叢集，通常意味著要同時應付多個不同的管理解決方案和其他不必要費用，對企業主營運而言反而有所挑戰。<br>為了推動國內企業更了解「混合雲平台+k8s」的具體內涵，【零壹主題策展】特別邀請 Nutanix 大中華區董事總經理 Daniel Chang 談談當前企業建構「混合雲平台+k8s」 的方案優勢，架構彈性扮演什麼重要角色？<br>Nutanix 已經在市場上協助哪些類型企業的業務模式成功轉型？讓每一間企業都能透過本地端 Kubernetes堆疊建構一流效率資料中心。",
                //       showText: false,
                //       textHeight: 0,
                //       Url:
                //         "https://www.zerone.com.tw/product/brand/nutanix/event/activity2024070101/DNMNE",
                //       btnStatus: "default",
                //     },
                //   ],
                // },
                {
                  date: "07/02",
                  list: [
                    {
                      title: "開發型容器",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/PaloAltoNetwork.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/NetApp.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "14:00-15:00",
                      text:
                        "在IT現代化的過程中，愈來愈多的企業使用容器與Kubernetes(K8S)相關技術，以更敏捷開發新的應用與服務。<br>容器、Kubernetes 與容器即服務 (CaaS) 已成為大規模封裝及協調服務的主流方法，因此企業必須確保他們已基於特定目的建立安全性，以針對其容器化應用程式解決弱點管理、合規性、執行階段保護和網路安全需求。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/netapp/event/activity2024070201/J1R7E",
                      btnStatus: "default",
                    },
                  ],
                },
                {
                  date: "07/03",
                  list: [
                    {
                      title: "贏在靈活度：一套架構、多種場景的時代來臨",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/VMware.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/NVIDIA.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "14:00-15:00",
                      text:
                        "全球每年產生的數據已成長至175ZB，相當於每天產生491EB的數據。<br>然而，這龐大的數據湧入卻對現有的雲端網絡和邊緣運算架構提出了嚴峻挑戰，隨著邊緣設備的不斷增加，傳輸大量數據至雲端將帶來龐大的成本，如何利用靈活的搬遷還有部署方式，因應企業的營運及規模調整成為IT人員最需解決課題。<br>有鑑於此，VMware Cloud Foundation(VCF)整合了 vSphere(運算)、vSAN(儲存)、NSX(網路微分段)和 Aria(雲端管理)，並支援容器化架構，是專為混合雲平台所設計的單一架構，與此同時，NVIDIA AI Enterprise針對VMware Cloud Foundation企業平台能夠簡化人工智慧應用程式的建置、共用和部署流程，且針對這些平台獲得了認證，提供雲端原生部署和基礎架構最佳化功能，支援靈活且可擴充的混合式雲端基礎架構。<br>本節課程將說明VCF如何簡化各種異質與混合雲端之間的環境管理，NVIDIA AI Enterprise如何簡化人工智慧應用程式的建置，有效降低資訊人員的負擔，讓資源聚焦在核心任務上！",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/nvidia/event/activity2024070301/OBAIB",
                      btnStatus: "default",
                    },
                  ],
                },
                {
                  date: "07/04",
                  list: [
                    {
                      title: "應用程式的安全開發與交付",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/F5.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/LucentSky.png",
                            import.meta.url
                          ).href,
                          css: "scale: 1.5;margin-left: 20px;",
                        },
                      ],
                      time: "14:00-15:00",
                      text:
                        "以容器、微服務為代表的雲原生技術蓬勃發展，許多IT人員想要建置完整部署的 Web 應用程式或服務，並將它部署為容器。<br>容器化的應用程式本身從內部來看可能不是單體式，而是結構化為數個程式庫、元件或甚至是階層 (應用程式層、領域層、資料存取層等)，但從外部來看，它是單一容器。<br>為了管理此模型，IT人員會部署單一容器來代表應用程式，並針對需求進行擴充，而完善的佈署可順利將應用程式的程式碼與在任何基礎設施上執行所需的所有檔案和程式庫繫結在一起，增加可攜性、可擴展性、敏捷性等好處。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/f5/event/activity2024070401/QZPKN",
                      btnStatus: "default",
                    },
                  ],
                },
              ],
            },
          },
          downloadData: {
            title: "白皮書下載",
            list: [
              {
                title: "實現5大效益-使用超融合基礎架構適用於 KUBERNETES",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/K8S+虛擬化/實現5大效益-使用超融合基礎架構適用於 KUBERNETES.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "NetApp Astra 加速開發及部署 Kubernetes 上建構的應用程式及服務",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/K8S+虛擬化/NetApp Astra 加速開發及部署 Kubernetes 上建構的應用程式及服務.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title:
                  "Palo Alto Networks VM-Series 虛擬新世代防火牆，保護您的 GCP 工作負載，讓您輕鬆迅速將企業關鍵應用程式移轉到雲端",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/K8S+虛擬化/Palo Alto Networks VM-Series 虛擬新世代防火牆，保護您的 GCP 工作負載，讓您輕鬆迅速將企業關鍵應用程式移轉到雲端.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "Veeam_10 大 VMware 備份最佳建議作法",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/K8S+虛擬化/Veeam_10 大 VMware 備份最佳建議作法.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "VMware vSphere Foundation 達成資料中心最佳化的企業 工作負載引擎",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/K8S+虛擬化/VMware vSphere Foundation 達成資料中心最佳化的企業 工作負載引擎.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
            ],
          },
          videoData: {
            title: "影片分享",
            list: [
              {
                title:
                  "NetApp Astra 適用於 Kubernetes 上建構的應用程式及服務，加速開發及部署應用程式",
                date: "",
                bgImg: "",
                videoSrc: "https://youtu.be/ORMP0TKii0Q",
              },
              {
                title: "PANW_vm-series-on-gcp-ds-zhtw",
                date: "",
                bgImg: "",
                videoSrc: "https://youtu.be/QVJusnMWEEI",
              },
            ],
          },
        },
        "it-management": {
          bgColor: "#EDF9F7",
          mainColor: "mint",
          bannerData: {
            title: "IT管理及效能監控",
            subTitle: "以簡馭繁的新型態IT管理",
            bgImgSrc: [
              new URL("@/assets/image/issues/IT/banner.jpg", import.meta.url).href,
              new URL("@/assets/image/issues/IT/banner-1.jpg", import.meta.url).href,
            ],
            bgImgSmSrc: [
              new URL("@/assets/image/issues/IT/banner-rwd.jpg", import.meta.url).href,
              new URL("@/assets/image/issues/IT/banner-rwd-1.jpg", import.meta.url).href,
            ],
            colorGroup: ["#48CFAD", "#37BC9B"],
          },
          introData: {
            title: "每間企業都需要的智能數位軍機處",
            content:
              "無所不在的AI將充斥於企業每個應用，在自動化環境下，越來越多的設備被整合到網路中。<br>這需要IT和OT系統的融合，為現代的IT管理開啟了各種複雜難題，IT系統傳統上主要用於資訊和通訊過程，但在相關網路串聯、生成式技術、強大勒索軟體、能源永續議題高漲等等趨勢下，如何掌握好的平台來以簡馭繁，成為各行各業的IT團隊年度必修課，所有企業的營運核心與成長動能也都將掌握在管理團隊的運籌帷幄。<br>本次零壹科技數位主題策展IT管理監控篇，將從新一代的IT管理團隊營運趨勢探討流程、維運、資安等議題的架構思維，營運當中自建與託管的效益分析、並利用良善的監測從資安、能源等數據的即時掌握還有預判等重要議題進行探討。<br>本次課程邀請到最新技術團隊成員及用戶顧問，我們都將從實務面反推各個技術適用的可行性與效益，為您解說當前IT團隊維運該如何布局才能事半功倍，一同打造無時無刻都能高度成長的數位化企業。",
          },
          agendaData: {
            title: "議程",
            contentData: {
              active: "07/08",
              contentList: [
                {
                  date: "07/08",
                  list: [
                    {
                      title: "讓數位能力與時俱進<br>Cisco 用 AI 協助企業持續強化數位營運",
                      tag: "名人堂",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Cisco.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "14:00-15:00",
                      text:
                        "生成式 AI 技術的爆發，無疑是全球最關注的焦點，開始有多家科技大廠積極應用於提升營運能力並重視使用 AI 所伴隨的資安問題。<br>同時間，ESG 愈來愈受到 CEO 的認可，成為企業策略中不可或缺的一部分，有助確保即使面臨地緣政治與經濟挑戰，業務亦能具有韌性並可實現其營收成長，如何讓企業的數位能力與時俱進，毫無疑問都是企業當前最大挑戰。<br>面對此波趨勢，身為全球技術領導者的 Cisco 如何以自身豐富的數位經驗協助企業創新產品與服務、降低成本、提高準確性，並確保資訊的安全無虞，同時在ESG與資安的課題上能為企業持盈保泰？<br>【零壹主題策展】特別邀請 Cisco，暢談目前在 IT 界的AI、ESG、資安議題？如何將複雜的 IT 架構需求，轉化為簡單、一體化的操作，一同揭曉其中奧秘！",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/cisco/event/activity2024070801/4PY1J",
                      btnStatus: "default",
                    },
                  ],
                },
                {
                  date: "07/09",
                  list: [
                    {
                      title: "全新進階的IT協作：多雲、安全、用戶體驗",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/PaloAltoNetwork.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/NetScout.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "11:00-12:30",
                      text:
                        "傳統IT基礎架構正在面臨許多挑戰，隨著雲端服務普及，使用者期望企業所提供的服務能夠與雲端服務一樣有同樣的敏捷性與部署速度。新世代的資安架構有兩大趨勢，一是走向雲原生，其次則是結合人工智慧（AI），為了達到這些成功要素，建構多雲、安全、敏捷彈性的IT架構，將視主宰企業能否在產業競爭中脫穎而出的關鍵。<br>企業需要一個更彈性、敏捷的自動化環境。本堂課程將以NetApp HCI超融合基礎架構搭配Data Fabric混合雲架構為題，搭配Palo Alto Networks 提供全方位符合 CNAPP 架構的 Prisms Cloud，透過非侵入性的整合，讓安全管理者即時掌握資產的使用狀況的管理並結合適用於任何環境、任何雲端、任何網路、任何服務的NETSCOUT網路、安全與應用效能監控平台等，進而協助用戶以最多功能的資料架構模式，完成新一代IT架構革命。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/netscout/event/activity2024070901/5SJ5E",
                      btnStatus: "default",
                    },
                    {
                      title: "打造新世代監控管理解決方案",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Extreme.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Vivotek.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "14:00-15:00",
                      text:
                        "根據IDC調查，各產業在數位轉型的策略發展下，企業新部署的IT基礎架構，已有50%以上的設備位於邊緣，所有接取網路的裝置也為支援物聯網應用，安全性亦成為應用模式成功與否的關鍵因素。<br>因此，對於現代IT團隊而言，強化網路架構與網路應用安全服務成為實現安全的雲端監控與永續管理最終目標。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/extreme_networks/event/activity2024070902/MRVZT",
                      btnStatus: "default",
                    },
                  ],
                },
                {
                  date: "07/10",
                  list: [
                    {
                      title: "多點布局、擴充先行",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/AOD.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Microsoft.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "11:00-12:00",
                      text:
                        "在現代企業，外部工作已成為常態，面對多樣的使用情境，端點管理的整合變得至關重要，資料的傳遞及保存方式，不但會不斷改變，隨著數位資料的數量愈來愈龐大，管理的複雜度及傳輸的速度也變得日益重要。<br>因此，企業IT因為要管理更多更複雜的端點，擴充性與安全性的規劃與考量無形當中帶來龐大工作量，",
                      Url:
                        "https://www.zerone.com.tw/product/brand/aod/event/activity2024071002/HNUEK",
                      btnStatus: "default",
                    },
                    {
                      title: "混合雲視野全開，優化您的基礎架構",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/NetApp.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Microsoft.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/AWS.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/GoogleCloud.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "14:00-15:00",
                      text:
                        "根據統計，84%台灣企業皆已使用2間以上公有雲服務，而有75%企業將工作負載遷移到雲端，至於駭客攻擊，台灣每秒遭受將近1.5萬次攻擊，居亞太之冠。<br>這些問題與狀況，AI都可協助。<br>企業儲存的資料量、複雜度與成本都在逐年增加，企業客戶普遍遭遇一些問題，包含企業本身的自動化程度增加、勒索病毒肆虐，甚至曾傳出鑽油平台被病毒滲透、多雲架構要如何更優化？",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/netapp/event/activity2024071001/LNJJU",
                      btnStatus: "default",
                    },
                  ],
                },
                {
                  date: "07/11",
                  list: [
                    {
                      title: "雲端創新力、架構更彈性",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Progress.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Nutanix.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "14:00-15:00",
                      text:
                        "隨著業界資安需求改變，越來越多企業希望為客戶建置專屬資安雲，隨之而來則須面對包含機房空間、電力、效能彈性、備份、廠牌整合與維護等問題，同時也更需根據企業的資安制度做彈性調整。<br>企業雲作業系統的架構需要具備高度整合性、安全性、彈性和效能，以應對企業日益增長和變化的IT需求。<br>透過與領先的技術公司合作，企業可以更好地實現數位轉型，提升營運效率，並確保資訊安全。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/nutanix/event/activity2024071101/ZUUNY",
                      btnStatus: "default",
                    },
                  ],
                },
                {
                  date: "07/12",
                  list: [
                    {
                      title: "善用IT管理監控 實現永續管理",
                      logo: [
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Cisco.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Splunk.png",
                            import.meta.url
                          ).href,
                        },
                        {
                          src: new URL(
                            "@/assets/image/issues/logo/Veritas.png",
                            import.meta.url
                          ).href,
                        },
                      ],
                      time: "14:00-15:00",
                      text:
                        "為了符合國際供應鏈規範，各企業紛紛著手制定減碳政策，ESG成為企業必須嚴正看待的議題，資料中心隨著AI導入，耗能越來越高，平均耗電量是傳統產業大樓50倍，思科在不影響營運，甚至可維持未來10年發展的情況下，將26個資料中心濃縮成14個，「沒有甚麼比直接砍掉更節省能耗，思科的ESG數位化整合範疇包括導入自動化碳盤查架構、IoT資訊安全部署、智慧物流及智慧辦公導入、能耗碳排系統戰情儀表板導入。<br>本節課程將透過Cisco的觀察，分享新一代資安長該如何利用有效的碳盤查架構強化ESG與企業永續，同時利用強而有力的Veritas備援機制能在關鍵時刻發揮作用，減少任何危機事件所可能帶來的碳損失。",
                      showText: false,
                      textHeight: 0,
                      Url:
                        "https://www.zerone.com.tw/product/brand/cisco/event/activity2024071201/RF1NI",
                      btnStatus: "default",
                    },
                  ],
                },
              ],
            },
          },
          downloadData: {
            title: "白皮書下載",
            list: [
              {
                title: "BMC Helix Discovery",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/IT監控管理/BMC Helix Discovery.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "Forescout-新世代NAC",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/IT監控管理/Forescout-新世代NAC.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "Forescout將零信任擴展至政府網路的最佳實踐",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/IT監控管理/Forescout將零信任擴展至政府網路的最佳實踐.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title:
                  "NetApp Cloud Insights 清楚掌控內部部署和雲端工作負載效能及使用狀態",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/IT監控管理/NetApp Cloud Insights 清楚掌控內部部署和雲端工作負載效能及使用狀態.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "NETSCOUT 深層網路健康預警系統",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/IT監控管理/NETSCOUT 深層網路健康預警系統.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "Palo Alto Networks Cortex XDR防禦、偵測、調查及回應所有威脅",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/IT監控管理/Palo Alto Networks Cortex XDR防禦、偵測、調查及回應所有威脅.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "Progress 運用豐富流量資料 推動網路運作轉型",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/IT監控管理/Progress 運用豐富流量資料 推動網路運作轉型.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
              {
                title: "Splunk IT Service Intelligence 使用 AIOps 保護服務效能",
                img: "",
                downloadLink: new URL(
                  "@/assets/download/books/IT監控管理/Splunk IT Service Intelligence 使用 AIOps 保護服務效能.pdf",
                  import.meta.url
                ).href,
                btnStatus: "default",
              },
            ],
          },
          videoData: {
            title: "影片分享",
            list: [
              {
                title:
                  "NetApp Cloud Insights 清楚掌控內部部署和雲端工作負載的效能、使用率與健全狀態",
                date: "",
                bgImg: "",
                videoSrc: "https://youtu.be/9PVAh0JBnmA",
              },
              {
                title: "Progress MOVEit 檔案傳輸管理軟體",
                date: "",
                bgImg: "",
                videoSrc: "https://www.youtube.com/watch?v=LoIzrOMV9Lw",
              },
              {
                title: "BMC Helix Discovery",
                date: "",
                bgImg: "",
                videoSrc: "https://youtu.be/spLUK61bdl8?si=9hjhlUXRsDLFw5Hk",
              },
              {
                title: "【Demo】Catalyst Center - Client 360 功能",
                date: "",
                bgImg: "",
                videoSrc: "https://www.youtube.com/watch?v=W0Urbh1BQZY",
              },
              {
                title: "Splunk IT Service Intelligence 使用 AIOps 保護服務效能",
                date: "",
                bgImg: "",
                videoSrc: "https://www.youtube.com/watch?v=PxbdgiXc5uY",
              },
              {
                title: "Forscout_新世代NAC",
                date: "",
                bgImg: "",
                videoSrc: "https://www.youtube.com/watch?v=QprjNxkJpC8",
              },
              {
                title: "NETSCOUT 深層網路健康預警系統",
                date: "",
                bgImg: "",
                videoSrc: "https://youtu.be/KS5rl_xhf-A",
              },
              {
                title: "PANW_cortex-xdr-ds-zhtw",
                date: "",
                bgImg: "",
                videoSrc: "https://youtu.be/6lsYvzBn0iA",
              },
            ],
          },
        },
      },
    };
  },
  components: {
    Banner,
    Intro,
    Btn,
  },
  async beforeMount() {
    if (localStorage.getItem("fromCampaign")) {
      localStorage.removeItem("fromCampaign");
    }
    window.addEventListener("scroll", this.handleScroll);
    const route = useRoute();
    if (route.params.alias) {
      this.bgColor = this.pageData[route.params.alias].bgColor;
      this.mainColor = this.pageData[route.params.alias].mainColor;
      this.bannerData = this.pageData[route.params.alias].bannerData;
      this.introData = this.pageData[route.params.alias].introData;
      this.agendaData = this.pageData[route.params.alias].agendaData;
      this.downloadData = this.pageData[route.params.alias].downloadData;
      this.videoData = this.pageData[route.params.alias].videoData;
      footerStore().setBackground(this.bgColor);
      await this.resetBookListLink();
    } else {
      window.location.href = "/";
    }
  },
  methods: {
    showBook(item) {
      if (!this.fileLoading) {
        if (item.downloadLink) {
          this.handleDownloadFile(item);
        } else {
          if (localStorage.getItem("auth.currentUser") && localStorage.getItem("auth.currentUser") !== 'null') {
            this.bookErrorModalData.text = "找不到檔案";
            this.bookErrorModalData.showLoginBtn = false;
          } else {
            this.bookErrorModalData.text = "您尚未登入，請登入後再進行下載";
            this.bookErrorModalData.showLoginBtn = true;
          }
          this.bookErrorModalData.isShow = true;
        }
      }
    },
    goToLogin() {
      localStorage.setItem("fromCampaign", this.$route.path);
      window.location = "/login";
    },
    async handleDownloadFile(file) {
        const currentUser = JSON.parse(localStorage.getItem("auth.currentUser"));
        try {
            this.fileLoading = true;
            const response = await axios({
                method: "POST",
                url: file.downloadLink,
                responseType: "blob",
                headers: {
                    Authorization: currentUser ? "Bearer " + currentUser.token : "",
                },
            });
            
            this.createDownloadLink(file.title || file.name, response.data);
            this.fileLoading = false;
        } catch (error) {
            this.fileLoading = false;
            if(error.response && error.response.status === 401) {
                this.bookErrorModalData.text = "抱歉，您的會員身份不符合下載此檔案的條件";
                this.bookErrorModalData.showLoginBtn = false;
                this.bookErrorModalData.isShow = true;
            }
        }
    },
    createDownloadLink(fileName = "filename", blobObject) {
        const url = window.URL.createObjectURL(blobObject);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
    },
    async resetBookListLink() {
      this.downloadData.list.forEach((item) => {
        item.downloadLink = "";
      });
      const currentUser = JSON.parse(localStorage.getItem("auth.currentUser"));
      const getBooksListApiRes = await axios({
        method: "GET",
        url: "/api/campaign/2024/files",
        headers: {
          Authorization: currentUser ? "Bearer " + currentUser.token : "",
        },
      });
      if (getBooksListApiRes.status === 200) {
        this.downloadData.list.forEach((item) => {
          const matchItem = getBooksListApiRes.data.data.items.find((_item) => {
            return item.title === _item.title;
          });
          if (matchItem) {
            item.downloadLink = matchItem.downloadLink;
          }
        });
      }
    },
    getBooksImgArrIndex(index) {
      return index % this.defaultBooksImgArr.length;
    },
    getAgendaBtnText(date, timeStr) {
      const now = new Date()
      const time = timeStr.split("-")[0]
      const targetTime = new Date('2024/'+date+" "+time)
      if(now < targetTime) {
        return "立即報名"
      } else {
        return "精彩回放"
      }
    },
    getAgendaTextHeight() {
      let activeData = this.agendaData.contentData.contentList.find((item) => {
        return item.date === this.agendaData.contentData.active;
      });
      if (activeData) {
        setTimeout(() => {
          let i = this.agendaData.contentData.contentList.indexOf(activeData);
          activeData.list.forEach((item, _i) => {
            let htmlObj = document.getElementById("AgendaItemText-" + i + "-" + _i);
            if (htmlObj) {
              item.textHeight = htmlObj.offsetHeight;
            }
          });
        }, 200);
      }
    },
    getVideoList(arr) {
      return Array.from({ length: Math.ceil(arr.length / 3) }, (_, index) =>
        arr.slice(index * 3, index * 3 + 3)
      );
    },
    videoIdFormate: (videoUrlStr) => {
      try {
        const UrlData = new URL(videoUrlStr);
        if (UrlData.host === "www.youtube.com" && UrlData.pathname === "/watch") {
          const params = new URLSearchParams(new URL(UrlData).search);
          return params.get("v");
        } else {
          return UrlData.pathname.replace("/", "");
        }
      } catch (error) {
        console.error("Invalid URL:", error.message);
      }
    },
    switchVideoModal(data) {
      this.videoModalData.isShow = !this.videoModalData.isShow;
      if (this.videoModalData.isShow) {
        this.videoModalData.source = data.videoSrc;
      }
    },
    handleScroll() {
      const DownloadTitleHtmlObj = document.getElementById("DownloadTitle");
      const VideoTitleHtmlObj = document.getElementById("VideoTitle");
      if (DownloadTitleHtmlObj) {
        const rectDownload = DownloadTitleHtmlObj.getBoundingClientRect();
        if (Math.abs(rectDownload.top) < 500 && Math.abs(rectDownload.top) > 230) {
          this.DownloadAnimateStatus = true;
        }
      }
      if (VideoTitleHtmlObj) {
        const rectVideo = VideoTitleHtmlObj.getBoundingClientRect();
        if (Math.abs(rectVideo.top) < 500 && Math.abs(rectVideo.top) > 230) {
          this.VideoAnimateStatus = true;
        }
      }
    },
    changeTab(index, direction = "") {
      let getTab = false;
      switch (direction) {
        case "next":
          getTab = this.agendaData.contentData.contentList[index + 1];
          break;
        case "prev":
          getTab = this.agendaData.contentData.contentList[index - 1];
          break;
        default:
          getTab = this.agendaData.contentData.contentList.find((item) => {
            return item.date === index;
          });
      }
      if (getTab) {
        this.agendaData.contentData.active = getTab.date;
      }
    },
    resetVideo() {
      this.videoModalData.source = "";
    },
  },
};
</script>
<style lang="scss">
.AgendaFixedMenuList {
  width: calc(100vw - 10px);
  margin-top: 5px;
  .AgendaFixedMenuItem {
    justify-content: center;
    font-weight: 700;
    font-size: 1rem;
    color: #1e1e1e;
    padding: 15px;
    &.active {
      background-color: #023150;
      color: white;
    }
  }
  .el-popper__arrow {
    display: none;
  }
}
.Issues {
  .agendaContent {
    position: relative;
    margin: auto;
    border: 0;
    border-radius: 20px;
    width: calc(100vw - 80px);
    max-width: 1760px;
    z-index: 1;
    @media (max-width: $md) {
      width: calc(100vw - 40px);
    }
    .AgendaFixedBox {
      display: none;
      @media (max-width: $md) {
        display: block;
      }
      .el-affix--fixed {
        left: 0;
        .AgendaFixedMenu {
          display: block;
        }
      }
      .AgendaFixedMenu {
        display: none;
        min-width: 100vw;
        text-align: center;
        background-color: white;
        padding: 15px;
        box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.3);
        .el-dropdown-link {
          font-weight: 700;
          font-size: 1rem;
          color: #1e1e1e;
          position: relative;
          &-icon {
            position: absolute;
            right: 0;
          }
        }
      }
    }
    .el-tabs {
      .el-tabs__header {
        .el-tabs__nav-wrap {
          &::after {
            display: none;
          }
          .el-tabs__nav-scroll {
            display: flex;
            justify-content: center;
            @media (max-width: $md) {
              .el-tabs__nav {
                width: 100%;
                flex-wrap: wrap;
                justify-content: center;
              }
            }
            .el-tabs__active-bar {
              max-width: 10px;
              height: 10px;
              border-radius: 50%;
              margin: 0 20px;
              @media (max-width: $md) {
                display: none;
              }
            }
            .el-tabs__item {
              font-size: 1rem;
              padding-bottom: 15px;
              &.is-active {
                color: black;
                @media (max-width: $md) {
                  position: relative;
                  &::after {
                    position: absolute;
                    content: "";
                    display: block;
                    width: 10px;
                    height: 10px;
                    border-radius: 50%;
                    background-color: var(--el-color-primary);
                    bottom: 0;
                  }
                }
              }
              @media (max-width: $md) {
                padding-left: 15px;
                padding-right: 15px;
              }
            }
          }
        }
      }
      .el-tabs__content {
        display: flex;
        justify-content: center;
        @media (max-width: $md) {
          margin: 0 -20px;
        }
      }
      .AgendaItem {
        display: flex;
        justify-content: center;
      }
      .ArrowBtn {
        display: flex;
        min-width: 80px;
        height: 100%;
        align-items: center;
        justify-content: center;
        @media (max-width: $md) {
          display: none;
          min-width: 60px;
        }
        .el-button {
          width: 46px;
          height: 46px;
          font-size: 1.375rem;
          color: var(--bs-primary-rgb);
          background-color: white;
          border-color: var(--bs-primary-rgb);
          @media (max-width: $md) {
            width: 40px;
            height: 40px;
          }
          &:hover {
            background-color: rgb(2, 49, 80);
            color: white;
          }
        }
      }
      .AgendaList {
        display: block;
        padding: 0;
        list-style-type: none;
        max-width: calc(1200px - 200px);
        padding: 0 15px;
        li {
          background-color: #f2f4f7;
          border-radius: 30px;
          padding: 40px 60px;
          margin: 20px 0;
          font-size: 1rem;
          width: 100%;
          @media (max-width: $md) {
            padding: 40px 20px;
          }
          .AgendaItemTitle {
            font-size: 1.25rem;
            font-weight: 900;
            @media (max-width: $md) {
              font-size: 1rem;
            }
          }
          p {
            margin: 0;
            &.AgendaItemText {
              position: relative;
              margin-top: 10px;
              padding-bottom: 1.5rem;
              max-height: 4.5rem;
              overflow: hidden;
              @media (max-width: $md) {
                font-size: 0.875rem;
                margin-top: 10px;
                margin-bottom: 30px;
              }
              &::after {
                content: "";
                background-color: #f2f4f7;
                display: block;
                position: absolute;
                bottom: 0;
                height: 1.8rem;
                width: 100%;
                @media (max-width: $md) {
                  height: 1.6rem;
                }
              }
              &.open {
                max-height: unset;
              }
              .more {
                position: absolute;
                background-color: #f2f4f7;
                color: #909399;
                bottom: 0;
                z-index: 2;
                height: 1.8rem;
              }
            }
          }
          .logoImg {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            margin: 20px -15px 0;
            max-width: 100%;
            @media (max-width: $md) {
              margin: 20px -15px 20px;
            }
            img {
              max-width: calc(100% / 3);
              height: auto;
              padding: 0 10px 20px;
              @media (max-width: $md) {
                max-width: calc((100% / 2) - 10px);
              }
            }
          }
        }
      }
    }
  }
  .Download {
    position: relative;
    overflow: hidden;
    z-index: 1;
    .Item {
      margin-bottom: 30px;
      .ItemImg {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 368px;
        border: 10px;
        background-color: white;
        border-radius: 20px;
        overflow: hidden;
        cursor: pointer;
        @media (max-width: $md) {
          height: 167px;
        }
        &::after {
          content: "";
          display: block;
          position: absolute;
          height: 100%;
          width: 100%;
          background-color: #212529;
          top: 0;
          left: 0;
          opacity: 0.5;
        }
        img {
          max-width: 70%;
          height: auto;
          transition: 0.5s;
          &.DefaultImg {
            max-width: none;
            width: auto;
            height: 100%;
          }
        }
        &:hover {
          img {
            transform: scale(1.2);
          }
          .ItemBtn {
            button {
              background-color: var(--el-button-hover-bg-color);
              border-color: var(--el-button-hover-bg-color);
              color: white;
            }
          }
        }
      }
      .ItemTitle {
        position: absolute;
        color: white;
        text-align: center;
        margin: 24px 0;
        font-size: 1.25rem;
        font-weight: 500;
        min-height: 90px;
        width: calc(100% - 48px);
        z-index: 2;
        @media screen and (max-width: $sm) {
          font-size: 1rem;
        }
        .el-text {
          color: inherit;
          font-size: inherit;
        }
      }
      .ItemBtn {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        bottom: 24px;
        z-index: 2;
        @media screen and (max-width: $sm) {
          bottom: 18px;
        }
        button {
          width: 60px;
          height: 60px;
          font-size: 1.5rem;
          @media screen and (max-width: $sm) {
            width: 30px;
            height: 30px;
            font-size: 1rem;
          }
        }
      }
    }
    &.green {
      .AnimateBgImg {
        &::after {
          background-color: #f7fbf2;
        }
      }
    }
    .AnimateBgImg {
      position: absolute;
      width: calc(100vw + 40px);
      height: auto;
      top: 0;
      left: -40px;
      z-index: -1;
      img {
        width: 100%;
        height: auto;
        max-height: 100vh;
        z-index: -2;
      }
      &::after {
        content: "";
        display: block;
        position: absolute;
        background-color: transparent;
        width: 100%;
        height: 100vw;
        top: 0;
        left: 0;
        z-index: 1;
      }
      &.animate {
        &::after {
          animation: right-to-left 2s ease-in forwards;
        }
      }
    }
  }
  .Video {
    position: relative;
    overflow: hidden;
    z-index: 1;
    .VideoList {
      position: relative;
      padding: 0 55px;
      .VideoListBtn {
        position: absolute;
        transform: translate(0 -50%);
        width: 46px;
        height: 46px;
        font-size: 1.375rem;
        top: 50%;
        color: var(--bs-primary-rgb);
        background-color: white;
        border-color: var(--bs-primary-rgb);
        &:hover {
          background-color: rgb(2, 49, 80);
          color: white;
        }
        &.Next {
          right: -55px;
        }
        &.Prev {
          left: -55px;
        }
      }
    }
    .VideoMobileList {
      list-style: none;
      padding: 0;
      .VideoItem {
        position: relative;
        margin: 20px 0;
        .VideoItemContent {
          .VideoItemContentBox {
            width: 135px;
            @media screen and (max-width: $sm) {
              width: 260px;
            }
          }
        }
      }
    }
    .VideoItem {
      position: relative;
      height: 353px;
      overflow: hidden;
      width: 100%;
      border-radius: 10px;
      z-index: 1;
      cursor: pointer;
      img {
        position: absolute;
        transform-origin: 0% 0%;
        transform: translate(-50%, -50%);
        top: 50%;
        left: 50%;
        width: auto;
        height: auto;
        min-width: 100%;
        min-height: 100%;
        z-index: -1;
      }
      &:hover {
        img {
          scale: 1.1;
          transition: 0.5s;
        }
      }
      &::after {
        content: "";
        display: block;
        position: absolute;
        height: 100%;
        width: 100%;
        background-color: #212529;
        top: 0;
        left: 0;
        opacity: 0.5;
      }
      .VideoItemContent {
        position: absolute;
        display: flex;
        justify-content: space-between;
        align-items: center;
        z-index: 1;
        color: white;
        padding: 0 25px 25px;
        bottom: 0;
        left: 00;
        width: 100%;
        min-height: 96px;
        &.first {
          .VideoItemContentBox {
            width: 260px;
          }
        }
        .VideoItemContentBox {
          width: 128px;
          .VideoItemDate {
            font-size: 1rem;
            margin-bottom: 12px;
          }
          .VideoItemTitle {
            font-size: 1.25rem;
          }
        }
        .VideoItemContentIcon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          border-radius: 10px;
          background-color: rgba(255, 255, 255, 0.4);
        }
      }
    }
    &.green {
      .AnimateBgImg {
        &::after {
          background-color: #f7fbf2;
        }
      }
    }
    .AnimateBgImg {
      position: absolute;
      width: calc(100vw + 40px);
      height: auto;
      top: -300px;
      left: -40px;
      z-index: -1;
      img {
        width: 100%;
        height: auto;
        max-height: 100vh;
        z-index: -2;
      }
      &::after {
        content: "";
        display: block;
        position: absolute;
        background-color: transparent;
        width: 100%;
        height: 100vw;
        top: 0;
        left: 0;
        z-index: 1;
      }
      &.animate {
        &::after {
          animation: left-to-right 2s ease-in forwards;
        }
      }
    }
  }
}
.VideoModal {
  border-radius: 10px !important;
  width: 80% !important;
  max-width: 700px;
  header.el-dialog__header {
    width: 100%;
    position: absolute;
    top: -15px;
    button.el-dialog__headerbtn {
      background-color: white;
      border: 1px solid #909399;
      border-radius: 50%;
      width: 30px;
      height: 30px;
    }
  }
  .el-dialog__body {
    iframe {
      min-height: 400px;
    }
  }
}
.bookErrorModal {
  border-radius: 10px !important;
  width: 80% !important;
  max-width: 350px;
}
@keyframes right-to-left {
  from {
    transform: translateX(0%);
  }
  to {
    transform: translateX(-100%);
  }
}
@keyframes left-to-right {
  from {
    transform: translateX(0%);
  }
  to {
    transform: translateX(100%);
  }
}
</style>
